export default "__VITE_ASSET__BnQqv7FF__"